import React from 'react';
import { Box, Drawer, useTheme, Theme, DrawerProps } from '@mui/material';
import Logo from '../shared/logo/Logo';
import SidebarItems from './SidebarItems';
import useIsMobile from '@/hooks/useIsMobile';

interface SidebarProps {
  isMobileSidebarOpen: boolean;
  onSidebarClose: DrawerProps['onClose'];
  isSidebarOpen: boolean;
}

const SIDEBAR_WIDTH = 270;

const Sidebar: React.FC<SidebarProps> = ({
  isMobileSidebarOpen,
  onSidebarClose,
  isSidebarOpen,
}) => {
  const theme = useTheme<Theme>();
  const isMobile = useIsMobile('lg');

  const handleMobileSidebarClose = () => {
    if (onSidebarClose) {
      onSidebarClose({}, 'backdropClick');
    }
  };

  const paperSx = {
    width: SIDEBAR_WIDTH,
    boxSizing: 'border-box',
    border: 0,
    bgcolor:
      theme.palette.mode === 'light'
        ? theme.palette.tokens.primary[50]
        : theme.palette.background.default,
    height: '100vh',
    overflow: 'auto',
  } as const;

  const SidebarContent = (
    <Box height="100%" py={2} display="flex" flexDirection="column" sx={{ minHeight: '100%' }}>
      <Box px={2}>
        <Logo />
      </Box>

      <Box mt={3} flexGrow={1}>
        <SidebarItems toggleMobileSidebar={isMobile ? handleMobileSidebarClose : undefined} />
      </Box>
    </Box>
  );

  if (!isMobile) {
    return (
      <Box
        component="nav"
        sx={{ width: SIDEBAR_WIDTH, flexShrink: 0 }}
        aria-label="Navegación lateral"
      >
        <Drawer open={isSidebarOpen} variant="permanent" anchor="left" PaperProps={{ sx: paperSx }}>
          {SidebarContent}
        </Drawer>
      </Box>
    );
  }

  return (
    <Drawer
      open={isMobileSidebarOpen}
      onClose={onSidebarClose}
      variant="temporary"
      anchor="left"
      ModalProps={{ keepMounted: true }} // Improve mobile performance
      PaperProps={{
        sx: {
          ...paperSx,
          boxShadow: theme.shadows[8],
        },
      }}
    >
      {SidebarContent}
    </Drawer>
  );
};

export default Sidebar;
